<template>
  <modal
    ref="modal"
    :name="identify"
    :click-to-close="true"
    :height="600"
    :width="400"
    :min-width="200"
    :min-height="200"
    :pivot-x="0"
    :pivot-y="0"
    draggable=".handle"
    adaptive
    resizable
    transition="nice-modal-fade"
    @closed="$emit('on-click-close')"
    @resize="resizeHandler"
  >
    <v-toolbar 
      color="secondary">
      <v-icon 
        color="white" 
        class="handle">fas fa-arrows-alt</v-icon>
      <v-spacer/>
      <v-toolbar-title 
        class="primarytext--text handle" 
        v-text="name"/>
      <v-spacer/>
      <v-btn 
        icon 
        @click.stop="$emit('on-click-close')">
        <v-icon 
          color="white"
        >close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout 
      row 
      wrap 
      class="modal-image-prewiev__wrap-content" 
      style="position:relative;">
      <v-flex 
        xl12 
        lg12 
        md12 
        class="modal-image-prewiev__content">
        <ImgViewZoom 
          v-if="ext !== 'pdf'" 
          :img-url="src" 
          :size="modalSize" 
          style="width:100%;height:100%;position:absolute;"/>
        <embed 
          v-if="ext === 'pdf'" 
          :src="src" 
          width="100%" 
          height="100%" 
          type="application/pdf">
      </v-flex>
    </v-layout>
  </modal>
</template>

<script>
import Vue from "vue";
import VModal from "vue-js-modal";
import ImgViewZoom from './ImgViewZoom.vue'

Vue.use(VModal, { dialog: true });
export default {
  name: "AccImagePreview",
  components: {ImgViewZoom},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    src: {
        type: String,
        default: ''
    },
    name: {
        type: String,
        default: ''
    }
  },
  data: () => ({
    identify: "image-prew-" + Date.now() + Math.floor(Math.random() * 1000 + 1),
    modalSize: {
      width: '100%',
      height: '100%'
    }
  }),
  computed: {
    ext() {
        return this.name ? this.name.split('.').pop() : ''
    }
  },
  watch: {
      show(val) {
          if (val) {
              this.$modal.show(this.identify);
          } else {
              this.$modal.hide(this.identify);
          }
      }
  },
  methods: {
    resizeHandler (mod) {
      this.modalSize = {
        width: mod.ref.clientWidth,
        height: mod.ref.clientHeight
      }
    }
  }
};
</script>

<style lang="scss">
.v--modal-overlay {
    background: none;
.modal-image-prewiev__wrap-content {
  height: calc(100% - 64px);
  modal-image-prewiev__content {
    height: 100%;
    img {
      display: block;
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }
}
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/ImagePdfPreview.vue